/**
 * Pauses execution for a specified number of milliseconds.
 *
 * @param {number} interval - The amount of time to sleep in milliseconds.
 * @returns {Promise<void>} A Promise that resolves after the specified interval.
 */
export function sleep(interval: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(resolve, interval)
  })
}
